import dataModel from "data-model";

const baseURL = "ManageBiReports";

export interface IBiReport {
  id: number;
  title: string;
  description: string;
  category: IBiReportCategory;
  assignedRoles?: IRoleOption[];
  tier: ITierOption;
  isActive: boolean;
  biReportType: IBiReportTypeOption;
}

export interface IBiReportTypeOption {
  typeTerm: string;
  url: string | null;
  biEmbedId: string | null;
  biWorkspaceId: string | null;
}

export interface IBiReportCategory {
  id: number;
  name: string;
}

export interface ITierOption {
  tierId: number;
  tierName: string;
  tierLevel: number;
}

export interface IAgencyOption {
  id: string;
  name: string;
}

export interface IRoleOption {
  id: string;
  name: string;
}

export interface IReportOption {
  id: string;
  name: string;
  category: string;
  description: string;
}

export interface fetchAssignmentOptionsResponse {
  assignedAgencies: IAgencyOption[];
  availableAgencies: IAgencyOption[];
  assignedReports: IReportOption[];
  availableReports: IReportOption[];
}

export interface fetchRoleAssignmentOptionsResponse {
  assignedRoles: IRoleOption[];
  availableRoles: IRoleOption[];
}

export interface UpdateAssignmentOptions {
  assignedAgencies: number[];
  assignedReports: number[];
}

class ManageReportService {
  fetchTierOptions = () => {
    return new Promise<ITierOption[] | null>((resolve, reject) => {
      dataModel
        .ajaxRequest(`${baseURL}/tiers`, "GET", null, true)
        .then(resolve)
        .catch((err: any) =>
          reject(
            (err.responseJSON && err.responseJSON.message) ||
              `An error occurred during request.`
          )
        );
    });
  };

  fetchAssignmentOptions = (tierId: number) => {
    return new Promise<fetchAssignmentOptionsResponse | null>(
      (resolve, reject) => {
        dataModel
          .ajaxRequest(`${baseURL}/assignments`, "GET", { tierId }, true)
          .then(resolve)
          .catch((err: any) =>
            reject(
              (err.responseJSON && err.responseJSON.message) ||
                `An error occurred during request.`
            )
          );
      }
    );
  };

  updateAssignmentOptions = (tierId: number, payload) => {
    return new Promise<fetchAssignmentOptionsResponse | null>(
      (resolve, reject) => {
        dataModel
          .ajaxRequest(`${baseURL}/assignments/${tierId}`, "PUT", payload, true)
          .then(resolve)
          .catch((err: any) =>
            reject(
              (err.responseJSON && err.responseJSON.message) ||
                `An error occurred during request.`
            )
          );
      }
    );
  };

  fetchReportOptions = () => {
    return new Promise<IBiReport[] | null>((resolve, reject) => {
      dataModel
        .ajaxRequest(`${baseURL}/reports`, "GET", null, true)
        .then(resolve)
        .catch((err: any) =>
          reject(
            (err.responseJSON && err.responseJSON.message) ||
              `An error occurred during request.`
          )
        );
    });
  };

  fetchCategoryOptions = () => {
    return new Promise<IBiReportCategory[] | null>((resolve, reject) => {
      dataModel
        .ajaxRequest(`${baseURL}/categories`, "GET", null, true)
        .then(resolve)
        .catch((err: any) =>
          reject(
            (err.responseJSON && err.responseJSON.message) ||
              `An error occurred during request.`
          )
        );
    });
  };

  fetchRoleAssignmentsByReport = (reportId: number) => {
    return new Promise<fetchRoleAssignmentOptionsResponse | null>(
      (resolve, reject) => {
        dataModel
          .ajaxRequest(`${baseURL}/role-assignments`, "GET", { reportId }, true)
          .then(resolve)
          .catch((err: any) =>
            reject(
              (err.responseJSON && err.responseJSON.message) ||
                `An error occurred during request.`
            )
          );
      }
    );
  };

  upsertReport = (payload: any) => {
    return new Promise((resolve, reject) => {
      dataModel
        .ajaxRequest(`${baseURL}/reports`, "POST", payload, true)
        .then(resolve)
        .catch((err: any) =>
          reject(
            (err.responseJSON && err.responseJSON.message) ||
              `An error occurred during request.`
          )
        );
    });
  };

  deleteReport = (reportId: number) => {
    return new Promise((resolve, reject) => {
      dataModel
        .ajaxRequest(`${baseURL}/reports/${reportId}`, "DELETE", null, true)
        .then(resolve)
        .catch((err: any) =>
          reject(
            (err.responseJSON && err.responseJSON.message) ||
              `An error occurred during request.`
          )
        );
    });
  };
}

const instance = new ManageReportService();
export default instance;
